module.exports = __webpack_public_path__ + "static/media/219-isle-of-man.14953fd2.svg";